import React from 'react';
import ListUsers from './ListUsers';
import { getCurrentDate, timeleft } from '../../../utils/dateFormatter';
import properties from '../../../modules/ajio-util/properties';

const imageBaseUrl = properties.getProperty('imageBaseUrl');

const LeaderBoard = ({
  eventsData,
  daySelectionHandler,
  selectedDate,
  isShowWinners,
  nextUpdateTime,
  winnersList
}) => {
  const fstDate = getCurrentDate().nextDay
    ? getCurrentDate().dateNumber
    : getCurrentDate().prevDay
    ? getCurrentDate().prevDay.split(' ')[0]
    : null;
  const scndDate = getCurrentDate().nextDay
    ? getCurrentDate().nextDay.split(' ')[0]
    : getCurrentDate().dateNumber;
  const selectedDay = `${selectedDate} ${getCurrentDate().month}`;

  return (
    <div>
      <div className="lb_heading">
        <p>#ForTheWin - Leaderboard</p>
        <p>
          Are you on our leaderboard yet? Shop big and you could be the winner of a fabulous iPhone
          8.
        </p>
      </div>
      <div className="desktop-banner">
        <img
          className="desktop-banner-lb"
          src={`${imageBaseUrl}/static/img/leaderboard/lb_banner.jpeg`}
          alt="Banner"
        />
      </div>
      {getCurrentDate().disable ? (
        <div className="feature-container feature-container-disabled">
          <div className="feature-timers">
            <div
              className={`timer-elem-left ${fstDate == selectedDate && 'selected_date'}`}
              onClick={() => daySelectionHandler(fstDate)}
            >
              <span className="feature__timer-date">19 {getCurrentDate().month}</span>
              <br />
            </div>
            <div
              className={`timer-elem-right ${getCurrentDate().nextDay && 'disabled'} ${scndDate ==
                selectedDate && 'selected_date'}`}
              onClick={() => daySelectionHandler(scndDate)}
            >
              <span className="feature__timer-date">20 {getCurrentDate().month}</span>
              <br />
            </div>
          </div>
          <div className="prev_day_header">
            <div className="">
              <p className="">
                <p>Add favourites to your bag</p>
                <p> and gear up #ForTheWin</p>
              </p>
              <p className="disabled_lb">Our leaderboard starts ticking at 12 AM on 19th Jan.</p>
            </div>
          </div>
        </div>
      ) : (
        <div className="feature-container">
          <div className="feature-timers">
            <div
              className={`timer-elem-left ${fstDate == selectedDate && 'selected_date'}`}
              onClick={() => daySelectionHandler(fstDate)}
            >
              <span
                className={`feature-timer-elem ${(isShowWinners || getCurrentDate().prevDay) &&
                  'no_padding'} ${getCurrentDate().nextDay && 'show-timer--left'}`}
              >
                {getCurrentDate().nextDay && (
                  <div>
                    <img
                      className="timer-clock"
                      src={`${imageBaseUrl}/static/img/leaderboard/clock.svg`}
                      alt="Clock icon"
                    />
                    <br />
                  </div>
                )}
                {isShowWinners || (winnersList && winnersList.length > 0) ? (
                  <img
                    className="desktop-wincup"
                    src={`${imageBaseUrl}/static/img/leaderboard/cup.svg`}
                    alt="Trophy icon"
                  />
                ) : !isShowWinners && getCurrentDate().prevDay ? (
                  <img
                    className="desktop-hourglass"
                    alt="Hourglass icon"
                    src={`${imageBaseUrl}/static/img/leaderboard/hourglass 2.svg`}
                  />
                ) : (
                  `${timeleft()} left`
                )}
              </span>
              <span className="feature__timer-date">
                {fstDate} {getCurrentDate().month}
              </span>
              <br />
              {isShowWinners ||
              (winnersList && winnersList.length > 0) ||
              getCurrentDate().prevDay ? (
                <span className="day_progress"> Day closed </span>
              ) : (
                <span className="day_progress"> Day in Progress </span>
              )}
            </div>
            <div
              className={`timer-elem-right ${getCurrentDate().nextDay && 'disabled'} ${scndDate ==
                selectedDate && 'selected_date'}`}
              onClick={() => daySelectionHandler(scndDate)}
            >
              {getCurrentDate().lbClosed &&
              winnersList &&
              winnersList.length > 0 &&
              isShowWinners ? (
                <img
                  className="desktop-wincup align-cup"
                  src={`${imageBaseUrl}/static/img/leaderboard/cup.svg`}
                  alt="Trophy icon"
                />
              ) : getCurrentDate().lbClosed && !isShowWinners ? (
                <img
                  className="desktop-hourglass align-cup"
                  alt="Hourglass icon"
                  src={`${imageBaseUrl}/static/img/leaderboard/hourglass 2.svg`}
                />
              ) : getCurrentDate().prevDay && getCurrentDate().lbClosed ? (
                `${timeleft()} lefttt`
              ) : (
                ''
              )}
              <span className={`feature__timer-date ${getCurrentDate().lbClosed && 'align-timer'}`}>
                {scndDate} {getCurrentDate().month}
              </span>
              <br />
              {getCurrentDate().prevDay && !getCurrentDate().lbClosed && (
                <span className="day_progress"> Day in Progress </span>
              )}
              <span
                className={`feature-timer-elem ${getCurrentDate().prevDay && 'show-timer--right'}`}
              >
                {getCurrentDate().prevDay && !getCurrentDate().lbClosed && (
                  <div>
                    <img
                      className="timer-clock"
                      src={`${imageBaseUrl}/static/img/leaderboard/clock.svg`}
                      alt="Clock icon"
                    />
                    <br />
                  </div>
                )}
                {getCurrentDate().prevDay && !getCurrentDate().lbClosed ? `${timeleft()} left` : ''}
              </span>
            </div>
          </div>
          {selectedDate == getCurrentDate().dateNumber ? (
            <div>
              {eventsData && eventsData.length > 0 ? (
                <div>
                  {!getCurrentDate().lbClosed && (
                    <div className="curr_day_header">
                      <div className="date_shopper_text">
                        {' '}
                        {getCurrentDate().today} - Top Shoppers*{' '}
                      </div>
                      <div className="updates_text">
                        <span className="">Updates every 30 mins</span>
                        <br />
                        <span className="">{`Next Update: ${nextUpdateTime}`}</span>
                      </div>
                    </div>
                  )}
                  <ListUsers
                    eventData={eventsData}
                    isShowWinners={isShowWinners}
                    day={selectedDay}
                  />
                </div>
              ) : (
                <div className="prev_day_header">
                  <img
                    src={`${imageBaseUrl}/static/img/leaderboard/hourglass 1.svg`}
                    alt="Hourglass icon"
                  />
                  <p>Our leaderboard is being updated</p>
                  <span>Go #ForTheWin and stand a chance to win a fabulous new iPhone 8!</span>
                </div>
              )}
            </div>
          ) : eventsData ? (
            <ListUsers eventData={eventsData} isShowWinners={isShowWinners} day={selectedDay} />
          ) : (
            <div className="prev_day_header">
              <h2>SOME ICON</h2>
              <p className="closed-day">Day Closed</p>
              <span>19 Jan Winners*</span>
              <br />
              <span>To be Announced by 20 Jan, 3 pm </span>
            </div>
          )}
          <div className="tnc_section">
            <span>
              *Subject to change basis returns and cancellation | Not valid on Tech products |{' '}
            </span>
            <a href="https://www.ajio.com/ajio-own-sale-policy"> View terms and conditions</a>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeaderBoard;
